"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22
  }, props), __jsx("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, __jsx("path", {
    d: "M3.438 16.5v3.438a1.375 1.375 0 001.374 1.375h4.125v-5.5a1.375 1.375 0 011.376-1.376h1.374a1.375 1.375 0 011.376 1.376v5.5h4.124a1.375 1.375 0 001.375-1.375V16.5",
    strokeWidth: 1.191671
  }), __jsx("path", {
    d: "M.688 15.125l9.34-9.34a1.375 1.375 0 011.945 0l9.34 9.34",
    strokeWidth: 1.191671
  }), __jsx("path", {
    d: "M15.125 8.938V7.562h3.438v4.813M15.695.688l-.373.497a.958.958 0 00.147 1.317h0a.958.958 0 01.146 1.316l-.373.498M19.133.688l-.373.497a.958.958 0 00.146 1.317h0a.958.958 0 01.147 1.316l-.373.498",
    strokeWidth: 1.191671
  })));
}
var _default = exports.default = SvgComponent;